import React from 'react';
import './SaveButton.css';

function SaveButton({onClickHandler, isFieldValid}) {
  return (
    <div className='prequal--web--save-button-container'>
      <button className='prequal--web--save-button' type='button' disabled={!isFieldValid} onClick={onClickHandler} data-testid='save'>
        Save
      </button>
    </div>
  );
}

export default SaveButton;
